import { render } from "./task-form.vue?vue&type=template&id=8ba1d24c"
import script from "./task-form.vue?vue&type=script&lang=ts"
export * from "./task-form.vue?vue&type=script&lang=ts"
script.render = render

export default script